export const CREATE_ACCOUNT_CONFIRMATION_PAGE_ID = 'confirmCreateAccountIdpScreen' as const;
